var _excluded = ["value", "additionalAmount", "currency", "textAlign", "isDisabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Group } from '../../../containers';
import { useIntl } from '../../../theme/i18n';
import { forwardRef } from '../../../utils';
import { defaultCurrency } from '../../../utils/currency-utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { _IconIndicator } from '../_IconIndicator';
import { _TableCell as TableCell } from '../_TableCell';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private Please use `Table.AmountCell` from `@melio/penny`.
 */
export var _TableAmountCell = forwardRef((_ref, ref) => {
  var {
    value = 0,
    additionalAmount,
    currency = defaultCurrency,
    textAlign = 'end',
    isDisabled
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    formatCurrency
  } = useIntl();
  var hasValue = !!value;
  var style = useMultiStyleConfig('TableAmountCell', {
    hasValue,
    additionalAmount: additionalAmount === null || additionalAmount === void 0 ? void 0 : additionalAmount.amount
  });

  var getAdditionalAmount = amount => "".concat(amount > 0 ? '+' : '').concat(formatCurrency(amount, currency));

  return /*#__PURE__*/_jsx(TableCell, _objectSpread(_objectSpread({
    ref: ref,
    "data-component": "_TableAmountCell",
    textAlign: textAlign,
    isDisabled: isDisabled
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "xxs",
      children: [/*#__PURE__*/_jsx(Box, {
        __css: style['value'],
        "aria-disabled": isDisabled,
        children: formatCurrency(hasValue ? value : 0, currency)
      }), hasValue && !!additionalAmount && /*#__PURE__*/_jsxs(Box, {
        __css: style['additionalAmount'],
        "aria-disabled": isDisabled,
        children: [getAdditionalAmount(additionalAmount.amount), additionalAmount.tooltip && !isDisabled && /*#__PURE__*/_jsx(_IconIndicator, {
          variant: "info",
          tooltip: additionalAmount.tooltip
        })]
      })]
    })
  }));
});
_TableAmountCell.displayName = '_TableAmountCell';
//# sourceMappingURL=_TableAmountCell.js.map